import Box from '@mui/material/Box';
import { Fragment, type ReactNode } from 'react';
import { stripMarkdown } from '../../utils/strip-markdown';

const HIGHLIGHT_REGEX = /<b>([^<]*)<\/b>/g;

function renderHighlighted(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null = HIGHLIGHT_REGEX.exec(text);
  while (match !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }
    nodes.push(
      <Box
        key={`h-${match.index}`}
        component="mark"
        sx={{
          fontWeight: 600,
          color: 'primary.dark',
          backgroundColor: 'primary.lighter',
          borderRadius: 0.5,
          px: 0.4,
          py: 0.05,
          mx: 0.1,
        }}
      >
        {match[1]}
      </Box>,
    );
    lastIndex = match.index + match[0].length;
    match = HIGHLIGHT_REGEX.exec(text);
  }
  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }
  return nodes;
}

interface SearchSnippetProps {
  snippet: string;
}

export function SearchSnippet({ snippet }: SearchSnippetProps) {
  const cleaned = stripMarkdown(snippet);
  return <Fragment>{renderHighlighted(cleaned)}</Fragment>;
}
